import { Button, ButtonProps } from '@fable/components'
import { useTheme } from '@fable/theme'

interface Props extends ButtonProps {
  selected: boolean
}

export const SearchFilterButton = ({
  selected,
  children,
  ...nativeProps
}: Props) => {
  const { colors, mediaQueries } = useTheme()

  const buttonStyles = {
    backgroundColor: selected ? colors.uiBlue : 'transparent',
    borderColor: selected ? colors.uiBlue : colors.uiGraphiteLight,
    color: selected ? colors.uiWhite : colors.uiBlack,
  }

  return (
    <Button
      outline
      custom={{
        padding: '0 20px',
        width: 'auto',
        height: '44px',
        borderWidth: '1px',
        whiteSpace: 'nowrap',
        ...buttonStyles,
        '&:hover': {
          ...buttonStyles,
        },
        [mediaQueries.mobileL]: {
          '&:hover': {
            backgroundColor: selected ? colors.uiBlue : 'transparent',
            borderColor: selected ? colors.uiBlue : colors.uiPewterGrey,
            color: selected ? colors.uiWhite : colors.uiPewterGrey,
          },
        },
      }}
      {...nativeProps}
    >
      {children}
    </Button>
  )
}
